import React from "react";
import Carousel from "../Carousel";
import Seo from "../Head";
import FormContactoContainer from "../FormContactoContainer";

export const TallerDetail = ({ itemDetail, onHandleCartModal }) => {
  // 1. PROCESAR IMÁGENES: Convertir de String (DB) a Array
  let imagenesArray = [];
  try {
    imagenesArray =
      typeof itemDetail.imagenes === "string"
        ? JSON.parse(itemDetail.imagenes || "[]")
        : itemDetail.imagenes;
  } catch (e) {
    imagenesArray = [];
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: imagenesArray.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <>
      <Seo
        title={itemDetail.titulo}
        description={itemDetail.precio}
        // Protección para la imagen de SEO
        image={imagenesArray.length > 0 ? imagenesArray[0].url : ""}
        pathSlug={window.location.href}
      />

      <div className="row">
        <div className="col-12 text-center pb-4">
          <h1 className="mb-0">{itemDetail.titulo}</h1>
          <div className="d-none d-md-block text-end arancel letraGris pt-3 me-2">
            {Number(itemDetail.precio) === 0 ? (
              "consultar próximo comienzo "
            ) : (
              <>
                arancel:{" "}
                <span className="negrita">
                  ${Number(itemDetail.precio).toLocaleString("es-AR")}{" "}
                </span>
              </>
            )}
          </div>
        </div>

        {/* MOBILE CAROUSEL */}
        <div
          className="d-md-none card col-12 col-md-6 ps-md-5 pe-md-5 mt-md-3"
          key={itemDetail.id}
        >
          <div>
            {imagenesArray.length > 0 && (
              <Carousel settings={settings}>
                {imagenesArray.map((img, index) => (
                  <div key={index}>
                    <img
                      src={img.url}
                      alt={itemDetail.titulo}
                      className="img-fluid"
                    />
                  </div>
                ))}
              </Carousel>
            )}
            <p className="text-end arancel letraGris me-2">
              {Number(itemDetail.precio) === 0 ? (
                "consultar próximo comienzo "
              ) : (
                <>
                  arancel:{" "}
                  <span className="negrita">
                    ${Number(itemDetail.precio).toLocaleString("es-AR")}{" "}
                  </span>
                </>
              )}
            </p>
          </div>
        </div>

        <div className="card pe-3 ps-3 col-12">
          <div>
            {/* DESKTOP CAROUSEL */}
            <div className="d-none d-md-block imgDesktop">
              {imagenesArray.length > 0 && (
                <Carousel settings={settings}>
                  {imagenesArray.map((img, index) => (
                    <div key={index} className="slick-slide">
                      <img
                        src={img.url}
                        alt={itemDetail.titulo}
                        className="img-fluid centered-image"
                      />
                    </div>
                  ))}
                </Carousel>
              )}
            </div>

            <div
              className="mt-3 mb-4 htmlEn"
              dangerouslySetInnerHTML={{ __html: itemDetail.descripcion }}
            />
          </div>
          <FormContactoContainer taller={itemDetail.titulo} />
        </div>
      </div>
    </>
  );
};
